<ng-container *ngIf="form">
  <div class="frequency-grid" [formGroup]="form">
    <div class="d-flex flex-column gap-3">
      <div *ngIf="!isBoardDirected" class="d-flex align-items-center" [style.gap.rem]="0.75">
        <app-radio-button-input
          controlId="monthly"
          formControlName="recurringPaymentFrequencyId"
          name="recurringPaymentFrequency"
          [value]="VariableBenefitPaymentFrequencyEnum.Monthly" />
        <app-form-option-label [labelFor]="'monthly'" i18n>Monthly</app-form-option-label>
      </div>
      <div class="d-flex align-items-center" [style.gap.rem]="0.75">
        <app-radio-button-input
          controlId="annual"
          formControlName="recurringPaymentFrequencyId"
          name="recurringPaymentFrequency"
          [value]="VariableBenefitPaymentFrequencyEnum.Annual" />
        <app-form-option-label [labelFor]="'annual'" i18n>Annual</app-form-option-label>
      </div>
    </div>
    <div class="dropdowns-grid">
      <div class="d-flex flex-column gap-1">
        <label i18n [for]="'recurringPaymentStartMonth'" class="form-input-label">Payment Start Month</label>
        <app-dropdown-input
          controlId="recurringPaymentStartMonth"
          formControlName="recurringPaymentStartMonth"
          [error]="displayError && form.controls.recurringPaymentStartMonth.invalid"
          [dropdowns]="monthDropdowns" />
        <app-form-error
          *ngIf="displayError && form.controls.recurringPaymentStartMonth.invalid"
          [errors]="form.controls.recurringPaymentStartMonth.errors"
          [customErrorMessages]="customErrorMessages.paymentStartMonth" />
      </div>

      <div class="d-flex flex-column gap-1">
        <label [for]="'recurringPaymentStartYear'" i18n class="form-input-label">Payment Start Year</label>
        <app-dropdown-input
          controlId="recurringPaymentStartYear"
          formControlName="recurringPaymentStartYear"
          [dropdowns]="(yearDropdowns$ | async) ?? []" />
      </div>
    </div>
  </div>
</ng-container>
